export function getFileName(filePath: string) {
  const index = filePath.lastIndexOf("/");
  return filePath.substring(index + 1, filePath.length);
}

export function getFileNameWithoutExt(filePath: string) {
  const name = getFileName(filePath);
  return filePath.substring(0, name.lastIndexOf("."));
}

export function getDirPath(filePath: string) {
  const index = filePath.lastIndexOf("/");
  return filePath.substring(0, index);
}